/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { CustomEventName, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';
import HaoPost from '@fe-common-ui/HaoPost';
import ReadMore from '@fe-common-ui/ReadMore';
import Section from '@fe-common-ui/Section';
import Slider from '@fe-common-ui/Slider';
import { SCREEN_SIZE } from '@fe-common-utils/constants/screen';
import { useIsInteractingObserver } from '@fe-common-utils/libs/hooks/useIsInteractingObserver';
import LinkFactory from '@fe-common-utils/libs/link';
import queries from '@fe-news/components/ReactQuery';
import { haoCategoryMapping } from '@fe-news/utils/hao';
import { styled } from '@linaria/react';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useRef } from 'react';

const GTM_EVENT_BUTTON_CLICK = {
  [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
  [GTMEventKey.SECTION]: '%p_鉅亨號貼文',
  [GTMEventKey.CLICK_ITEM]: '看更多'
};

const GTM_EVENT_IMP_PLACEMENT = {
  [GTMEventKey.EVENT_NAME]: CustomEventName.IMP_PLACEMENT,
  [GTMEventKey.SECTION]: '%p_鉅亨號貼文'
};

const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
};

const Container = styled.div`
  margin-bottom: 40px;
  min-height: 210px;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    margin-bottom: 32px;
  }
`;

const PostContainer = styled.div`
  padding: 0 24px;
`;

const Hao = ({
  categoryId = 0,
  isMobile,
  isBcNews
}: {
  categoryId?: number;
  isMobile?: boolean;
  isBcNews?: boolean;
}) => {
  const title = isMobile ? '鉅亨號' : '鉅亨號貼文';
  const haoCategory = (categoryId && categoryId > 0 && haoCategoryMapping(categoryId)) || '';

  const { data, isError } = useQuery({
    ...queries.hao.haoApi(haoCategory),
    initialData: []
  });

  const countHaoFirstEnter = useRef(0);
  const onEnterHao = useCallback(() => {
    if (!countHaoFirstEnter.current) {
      countHaoFirstEnter.current = 1;
      sendGTM(GTM_EVENT_IMP_PLACEMENT);
    }
  }, []);

  const haoReference = useIsInteractingObserver(onEnterHao, OBSERVER_OPTIONS);

  const url = isBcNews ? `${LinkFactory.anueHaoLink}/wall/blockchain` : LinkFactory.anueHaoLink;

  if (isError) return null;

  return (
    <Container className='hao-posts' ref={haoReference}>
      <Section title={title} RightContent={<ReadMore url={url} target='_self' gtmEvent={GTM_EVENT_BUTTON_CLICK} />} />
      <PostContainer>
        <Slider gap={24} buttonPadding={-20}>
          {data?.map((item: any, index: number) => <HaoPost item={item} key={`hao-post-${index}`} />)}
        </Slider>
      </PostContainer>
    </Container>
  );
};

export default Hao;
